// extracted by mini-css-extract-plugin
export default {"floatingNav":"styles_floatingNav__9u+S6","floatingNav--visible":"styles_floatingNav--visible__ReuxS","navItem":"styles_navItem__S0nUS","navLabel":"styles_navLabel__3JjFh"};